import { StyledChipWrapper, TextWrap, StyledButton, StyledChipInputWrapper } from './styled';
import React, { useMemo } from 'react';
import { Icon } from '../icon';
export const Chip = ({ id, title, disabled, isStatic, onRemove, size = 'small', type, ...props }) => {
    const shouldRenderButton = useMemo(() => {
        return !disabled && !isStatic && type === 'chipInput';
    }, [disabled, isStatic, type]);
    const Wrapper = type === 'chip' ? StyledChipWrapper : StyledChipInputWrapper;
    return (React.createElement(Wrapper, { type: type, disabled: disabled || isStatic, sizeComponent: size, ...props },
        React.createElement(TextWrap, { sizeComponent: size, title: title, disabled: disabled, ...props }, title),
        shouldRenderButton ? (React.createElement(StyledButton, { "data-chip-id": id, onClick: onRemove, title: "Remove", variant: "transparent", disabled: disabled, EndIcon: React.createElement(Icon, { name: "close", size: "small" }) })) : null));
};
